import { getSortedIndexName } from './getSortedIndexName';
import { searchSubmitHandler } from './searchSubmitHandler';
import { updateFilters } from './updateFilter';

export const SearchService = {
  getSortedIndexName,
  searchSubmitHandler,
  updateFilters,
};
